<template>
  <div class="home">
    <img alt="SkillSync logo" src="../assets/logo-splash.png">
    <Login v-if="!forgotPasswordVisible" @forgot-password-click="handleForgotPasswordClick" />
    <ForgotPassword v-if="forgotPasswordVisible" @cancel-clicked="handleCancelClicked" />
  </div>
</template>
<script>
// @ is an alias to /src
import Login from '@/components/Login.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';

export default {
  name: 'HomeView',
  components: {
      Login,
      ForgotPassword
  },
  data () {
    return {
      forgotPasswordVisible: false
    }
  },
  methods: {
    handleForgotPasswordClick() {
      this.forgotPasswordVisible = true;
    },
    handleCancelClicked() {
      this.forgotPasswordVisible = false;
    }
  }
}
</script>
<style>
.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/login-background.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.dark-table {
    background-color: #292929; /* Dark gray background */
    color: #fff; /* White text color */
    border-collapse: collapse; /* Remove default cell spacing */
    width: 100%;
}

.dark-table th,
.dark-table td {
    padding: 10px; /* Add padding to cells */
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #3f3f3f; /* Darker gray for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #333; /* Darker background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #4f4f4f; /* Darker background for hover effect */
}

/* Hint of purple */
.dark-table th,
.dark-table td {
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #27202c; /* Purple background for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #363438; /* Purple background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #2b1542; /* Darker purple background for hover effect */
}

.panel-style {
  background-color: #181a1b; 
  color: white; 
  padding: 20px; 
  border-radius: 10px;
}

@media only screen and (min-device-width : 375px) and (max-device-width : 812px) and (-webkit-min-device-pixel-ratio : 2) and (orientation : portrait) {
  .panel-style {
    background-color: #181a1b; 
    color: white; 
    padding: 20px; 
    border-radius: 10px;
  }
}
</style>
